__turbopack_context__.v({
  "fadeIn": "MXAlvq_fadeIn",
  "fadeInUp": "MXAlvq_fadeInUp",
  "mobileMenu": "MXAlvq_mobileMenu",
  "mobileMenuContent": "MXAlvq_mobileMenuContent",
  "mobileMenuFooter": "MXAlvq_mobileMenuFooter",
  "mobileMenuLink": "MXAlvq_mobileMenuLink",
  "mobileMenuLinkArrow": "MXAlvq_mobileMenuLinkArrow",
  "mobileMenuLinkArrowOpen": "MXAlvq_mobileMenuLinkArrowOpen",
  "mobileMenuLinkText": "MXAlvq_mobileMenuLinkText",
  "mobileMenuOpen": "MXAlvq_mobileMenuOpen",
  "mobileMenuSectionTitle": "MXAlvq_mobileMenuSectionTitle",
  "mobileMenuSubLink": "MXAlvq_mobileMenuSubLink",
  "mobileMenuSubNavigation": "MXAlvq_mobileMenuSubNavigation",
  "mobileMenuSubNavigationOpen": "MXAlvq_mobileMenuSubNavigationOpen",
  "mobileNavigation": "MXAlvq_mobileNavigation",
  "mobileNavigationContent": "MXAlvq_mobileNavigationContent",
  "navigation": "MXAlvq_navigation",
  "navigationContent": "MXAlvq_navigationContent",
  "navigationItem": "MXAlvq_navigationItem",
  "navigationItemArrow": "MXAlvq_navigationItemArrow",
  "navigationItemArrowOpen": "MXAlvq_navigationItemArrowOpen",
  "navigationItemSelected": "MXAlvq_navigationItemSelected",
  "navigationLogo": "MXAlvq_navigationLogo",
  "navigationMenu": "MXAlvq_navigationMenu",
  "navigationMenuContent": "MXAlvq_navigationMenuContent",
  "scrolled": "MXAlvq_scrolled",
  "subNavigation": "MXAlvq_subNavigation",
  "subNavigationContainer": "MXAlvq_subNavigationContainer",
  "subNavigationContainerAnchorRight": "MXAlvq_subNavigationContainerAnchorRight",
  "subNavigationContainerOpen": "MXAlvq_subNavigationContainerOpen",
  "subNavigationItem": "MXAlvq_subNavigationItem",
  "subNavigationItemSelected": "MXAlvq_subNavigationItemSelected",
  "subNavigationOpen": "MXAlvq_subNavigationOpen",
  "subNavigationSmall": "MXAlvq_subNavigationSmall",
});
